module.exports = __webpack_public_path__ + "static/FoundersGrotesk-Regular-8f3bbb36988ff9f66ea1361c65c0fab4.eot";